import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { apiClient } from '../api/apiClient';
import { markReturningVisitor } from '../utils/returningVisitor';

function PrivateRoute({ role, children }) {
  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(false);
  const [myRole, setMyRole] = useState('');

  useEffect(() => {
    let active = true;
    (async () => {
      // 위장 접속 중이면 sessionStorage imp_token, 일반이면 localStorage accessToken 확인
      const token = apiClient.isImpersonating()
        ? sessionStorage.getItem('pg_imp_token')
        : localStorage.getItem('accessToken');
      if (!token) {
        if (active) {
          setAllowed(false);
          setLoading(false);
        }
        return;
      }

      // 로그인 토큰을 들고 업무 화면에 옴 = 고객 기기 → 첫 주소에서 소개 페이지 대신 로그인 화면(2026-09-28).
      //   오늘 이전부터 로그인해 있던 고객도 여기서 표시가 생긴다. 토큰이 만료돼 곧 지워져도 남도록 /api/me 전에.
      markReturningVisitor();
      const result = await apiClient.get('/api/me');
      if (!active) return;

      if (!result.ok) {
        if (!apiClient.isImpersonating()) localStorage.removeItem('accessToken');
        setAllowed(false);
        setLoading(false);
        return;
      }

      const userRole = result.data?.user?.role || '';
      setMyRole(userRole);

      if (!role) {
        setAllowed(true);
      } else if (role === 'employee') {
        setAllowed(userRole === 'employee' || userRole === 'admin');
      } else {
        setAllowed(userRole === role);
      }

      setLoading(false);
    })();

    return () => {
      active = false;
    };
  }, [role]);

  if (loading) return <div style={{ padding: 24 }}>로딩 중...</div>;
  if (!allowed) {
    const hasToken = apiClient.isImpersonating()
      ? Boolean(sessionStorage.getItem('pg_imp_token'))
      : Boolean(localStorage.getItem('accessToken'));
    if (!hasToken) return <Navigate to="/login" replace />;
    return <Navigate to="/dashboard" replace state={{ role: myRole }} />;
  }

  return children;
}

export default PrivateRoute;
